import React from 'react'
import {
  // DotLoading,
  AutoCenter
} from 'antd-mobile'

function Loading() {
  return <AutoCenter>{/* <DotLoading color="#33C9C1" /> */}</AutoCenter>
}

export default Loading
